import { INgayNghi } from "../models/response/category/INgayNghi";
import { apiClient } from "./apiClient";
export const NGAY_NGHI_API_END_POINT = "ngay-nghi";

export const ngayNghiApi = {
    select_all: () => apiClient.get(`${NGAY_NGHI_API_END_POINT}`),
    select_by_coso: (dm_coso_id: number) => apiClient.get(`${NGAY_NGHI_API_END_POINT}/co-so/${dm_coso_id}`),
    detail: (id: number) => apiClient.get(`${NGAY_NGHI_API_END_POINT}/${id}`),
    insert: (payload: INgayNghi) => apiClient.post(`${NGAY_NGHI_API_END_POINT}`, payload),
    update: (payload: INgayNghi) => apiClient.put(`${NGAY_NGHI_API_END_POINT}`, payload),
    delete: (id: number) => apiClient.delete(`${NGAY_NGHI_API_END_POINT}/${id}`),
}